<!-- Componente genérico de subida de archivos -->
<!-- Puede usarse en dialogs, formularios, cards, etc. -->
<div class="upload-container">
  <!-- Título opcional -->
  @if (title) {
    <h2 class="upload-title">{{ title }}</h2>
  }

  <div class="upload-content">
    <div class="upload-form">
      <!-- Descripción opcional -->
      @if (description) {
        <p class="dialog-description">{{ description }}</p>
      }

      <!-- Zona de drag & drop -->
      <div
        class="file-upload-section"
        [class.dragging]="isDragging()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          style="display: none"
          [accept]="getAcceptAttribute()"
          [multiple]="multiple"
        />

        @if (selectedFiles().length === 0) {
          <div class="upload-placeholder">
            <mat-icon class="upload-icon">cloud_upload</mat-icon>
            <p class="upload-text">Arrastra archivos aquí o haz clic para seleccionar</p>
            <p class="upload-hint">También puedes pegar con Ctrl/Cmd + V</p>
            <button type="button" mat-stroked-button color="primary" (click)="fileInput.click()" class="upload-button">
              <mat-icon>upload_file</mat-icon>
              Seleccionar archivo{{ multiple ? 's' : '' }}
            </button>
            <p class="file-hint">Formatos aceptados: {{ allowedExtensions.join(', ') }} (máx. {{ formatFileSize(maxFileSize) }})</p>
          </div>
        } @else {
          <div class="files-list">
            @for (file of selectedFiles(); track file.name + file.size; let idx = $index) {
              <div class="file-chip">
                <mat-icon class="file-icon">description</mat-icon>
                <div class="file-info">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">{{ formatFileSize(file.size) }}</span>
                </div>
                <button type="button" mat-icon-button color="warn" (click)="removeFile(idx)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }

            @if (multiple) {
              <button type="button" mat-stroked-button color="primary" (click)="fileInput.click()" class="add-more-button">
                <mat-icon>add</mat-icon>
                Añadir más archivos
              </button>
            }
          </div>
        }

        @if (fileError()) {
          <div class="file-error">
            <mat-icon class="error-icon">error</mat-icon>
            <span>{{ fileError() }}</span>
          </div>
        }
      </div>

      <!-- Campo de comentario opcional -->
      @if (showComment) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Comentario (opcional)</mat-label>
          <textarea
            matInput
            [value]="comment()"
            (input)="onCommentChange($any($event.target).value)"
            rows="3"
            placeholder="Añade un comentario sobre los archivos"
          ></textarea>
        </mat-form-field>
      }
    </div>
  </div>
</div>

<!--
  Nota: Este componente NO incluye botones de acción (guardar/cancelar)
  El componente padre es responsable de:
  1. Escuchar los eventos filesChanged y commentChanged
  2. Llamar a getFiles() y getComment() cuando necesite los datos
  3. Proporcionar sus propios botones de acción según el contexto
-->
